import { Box, Flex, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import Loader from 'components/Loader';
import { AnimatedMascot } from 'components/Mascot';
import Settings from 'containers/Integrations/Paycor/Settings';
import { useFetchPaycorAuthorizationURL } from 'hooks/integrations/paycor/useFetchPaycorAuthorizationURL';
import { useSavePaycorToken } from 'hooks/integrations/paycor/useSavePaycorToken';
import { useIntegrationStore } from 'store/useIntegrationStore';

const Configuration = () => {
  const { data: paycorRedictURLData, status: paycorAuthorizationURLStatus } = useFetchPaycorAuthorizationURL();
  const { status: paycorAuthSaveStatus, mutate: mutateSavePaycorToken } = useSavePaycorToken();

  const { t } = useTranslation(['integrations']);

  const integrationListData: any = useIntegrationStore(state => state.integrationList);
  const paycorIntegrationData = integrationListData.filter((tab: any) => tab.key === 'paycor')[0];

  /**
   * Configure handlers to parse paycor code and state from the URL in Integrations.tsx file.
   * Extracted code and state from the popup window post as message to the window opener with code, state and integrations data
   * Configuration component will handle the message event and save the paycor token
   */
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // Security Check
      if (event.origin !== window.location.origin) return;

      if (event.data?.code && event.data?.state) {
        mutateSavePaycorToken({ code: event.data.code, state: event.data.state });
        window.removeEventListener('message', handleMessage);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const onEnable = () => {
    const width = 600;
    const height = 420;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;
    const title = `Paycor Login`;
    const url = paycorRedictURLData?.payload?.authorization_url;

    const popup = window.open(url, title, `width=${width},height=${height},left=${left},top=${top}`);

    if (!popup) {
      alert('Popup blocked! Please allow popups in your browser.');
      return;
    }
  };

  if (paycorAuthSaveStatus === 'loading') return <Loader height="200px" />;

  return (
    <>
      {!paycorIntegrationData.is_connected ? (
        <Flex flexDirection="column">
          <Box
            padding="20px 40px"
            border="1px solid"
            borderColor="gray.400"
            background="white"
            textAlign="center"
            mb={6}
          >
            <AnimatedMascot type="barking" />
            <Text>{t('integrations:clickToEnable')}</Text>
          </Box>
          <Button ml="auto" isLoading={paycorAuthorizationURLStatus === 'loading'} onClick={onEnable}>
            {t('integrations:enable')}
          </Button>
        </Flex>
      ) : (
        <Settings />
      )}
    </>
  );
};
export default Configuration;
